exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".exam-screen {\n  background-color: #EBEAEB;\n  padding: 30px 50px; }\n\n@media (max-width: 767px) {\n  .exam-screen {\n    padding: 0px 44px;\n    margin-top: -24px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/@mprep/shared/lib/angular/components/exam-screen/exam-screen.scss
// module id = bX5H
// module chunks = 3